import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DiscountLabel from './DiscountLabel'
import WishlistHeart from 'Wishlist/WishlistHeart'
import CardImage from 'Catalog/Product/ProductCard/CardImage'
import CardTitle from 'Catalog/Product/ProductCard/CardTitle'
import CardPartner from 'Catalog/Product/ProductCard/CardPartner'
import yn from 'yn'

import Availability from 'Catalog/Availability'
import CardInternal from 'Catalog/Product/ProductCard/CardInternal'
import IsResponsiveEnabledContext from 'Shared/IsResponsiveEnabledContext'

import MediaQuery from 'react-responsive'
import Tagging from './Tagging'

import { withRouter } from 'react-router'
class ProductCard extends Component {
  constructor (props) {
    super(props)

    this.state = {
      sendGTM: false
    }

    this.TaggingClick = this.TaggingClick.bind(this)
  }

  TaggingClick () {
    this.setState({ sendGTM: true })
  }

  render () {
    const { sku,
      imageUrl,
      name,
      originalId,
      vendorId,
      isResponsiveEnabled,
      discount } = this.props

    const className = this.props.className ? this.props.className : ''

    return (
      <IsResponsiveEnabledContext.Provider value={isResponsiveEnabled}>
        <div className={`item card ${className}`}>
          { this.state.sendGTM && <Tagging type='click' {...this.props} /> }
          <div className='bordered radius border-color-ui-2 bg-white h-100'>
            <MediaQuery minDeviceWidth={1025}>
              <WishlistHeart className='card-wishlist pos-absolute' sku={sku} name={name} />
            </MediaQuery>
            <div className='row mx-1 px-0'>
              { discount && <div className='col-12 discount-whishlist'>
                <DiscountLabel discount={discount} />
              </div> }
              <CardImage
                imageUrl={imageUrl}
                href={`/products/${sku}`}
                TaggingClick={this.TaggingClick}
              />
              <CardInternal>
                {yn(process.env.REACT_APP_SHOW_CARD_VENDOR, { default: true }) && <CardPartner vendorId={vendorId} />}
                <CardTitle title={name} href={`/products/${sku}`} TaggingClick={this.TaggingClick} />
                {vendorId && originalId && sku && (
                  <Availability
                    sku={sku}
                    originalId={originalId}
                    vendorId={vendorId}
                  />
                )}
              </CardInternal>
            </div>
          </div>
        </div>
      </IsResponsiveEnabledContext.Provider>
    )
  }
}

ProductCard.propTypes = {
  sku: PropTypes.string.isRequired,
  name: PropTypes.string,
  imageUrl: PropTypes.string,
  originalId: PropTypes.string,
  vendorId: PropTypes.string,
  className: PropTypes.string,
  isResponsiveEnabled: PropTypes.bool,
  discount: PropTypes.number,
  history: PropTypes.object
}

export default withRouter(ProductCard)



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductCard/ProductCard.js